import React from 'react';
import BIFillFormAction from './BIFillFormAction';

class FillFormAction extends BIFillFormAction {
  constructor(props) {
    super(props);

    const { action, prefilledData = {} } = props;
    const { hr_fill_basic_information_form: { questions }, employee_information: ei = {} } = action;

    this.formConsumer = React.createRef();
    this.state = {
      questions: this.questionsWithAnswers(questions, prefilledData, ei),
      actionStatus: action.status,
      saveDataError: false,
    };
  }
}

export default FillFormAction;
